import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export const complexFiltersApi = createApi({
  reducerPath: 'complexFiltersApi',
  baseQuery,
  tagTypes: ['ComplexFilter'],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    applyComplexFilter: builder.mutation({
      query: (conditions) => ({
        url: 'complex-filters/apply',
        method: 'POST',
        body: { conditions },
      }),
    }),
    saveComplexFilter: builder.mutation({
      query: ({ name, conditions }) => ({
        url: 'complex-filters',
        method: 'POST',
        body: { name, conditions },
      }),
      invalidatesTags: [{ type: 'ComplexFilter', id: 'LIST' }],
    }),
    saveUserFilter: builder.mutation({
      query: (conditions) => ({
        url: 'complex-filters/save',
        method: 'POST',
        body: { conditions },
      }),
    }),
    getCurrentUserFilter: builder.query({
      query: () => 'complex-filters/current',
      providesTags: [{ type: 'ComplexFilter', id: 'CURRENT' }],
    }),
    getComplexFilters: builder.query({
      query: () => 'complex-filters',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'ComplexFilter', id })),
              { type: 'ComplexFilter', id: 'LIST' },
            ]
          : [{ type: 'ComplexFilter', id: 'LIST' }],
    }),
    getComplexFilter: builder.query({
      query: (id) => `complex-filters/${id}`,
      providesTags: (result, error, id) => [{ type: 'ComplexFilter', id }],
    }),
    deleteComplexFilter: builder.mutation({
      query: (id) => ({
        url: `complex-filters/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'ComplexFilter', id },
        { type: 'ComplexFilter', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useApplyComplexFilterMutation,
  useSaveComplexFilterMutation,
  useSaveUserFilterMutation,
  useGetCurrentUserFilterQuery,
  useGetComplexFiltersQuery,
  useGetComplexFilterQuery,
  useDeleteComplexFilterMutation,
} = complexFiltersApi;
